<template>
  <el-main class="page-content-margin-unset">
    <div class="table-top dk-li">
      <el-input
        placeholder="请输入用户昵称/手机号/订单号进行搜索"
        v-model="body.keyword"
        clearable
        @change="handleCurrentChange()"
        class="input-with-select dk_input">
        <el-button
          @click="handleCurrentChange()"
          slot="append"
          icon="el-icon-search"/>
      </el-input>
      <span style="line-height: 40px;margin-right:10px">创建时间</span>
      <el-date-picker
        style="width:240px"
        clearable
        value-format="yyyy-MM-dd"
        @change="onTimeChange()"
        v-model="times"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"/>
      <span style="line-height: 40px;margin-right:10px">支付时间</span>
      <el-date-picker
        style="width:240px"
        clearable
        value-format="yyyy-MM-dd"
        @change="onTimeChange1()"
        v-model="times1"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"/>
      <div/>
      <div>
        <el-button
          type="primary"
          plain
          @click="event().toExportClick()">
          导出Excel
        </el-button>
        <a
          ref="export"
          style="display:none"
          :href="url"/>
      </div>
    </div>
    <el-radio-group
      class="dk-li"
      v-model="body.status"
      @change="handleCurrentChange()">
      <el-radio-button
        :label="item.value"
        v-for="(item,index) in orderArr"
        :key="index">{{ item.label }}</el-radio-button>
    </el-radio-group>
    <!-- 表格 -->
    <el-table
      border
      :data="tableData">
      <el-table-column
        prop="order_id"
        label="订单号"/>
      <el-table-column
        prop="create_time"
        label="创建时间"/>
      <el-table-column
        prop="name"
        label="用户昵称"/>
      <el-table-column
        prop="mobile"
        label="手机号"/>
      <el-table-column
        prop="point"
        label="兑换积分数"/>
      <el-table-column
        prop="pay_time"
        label="兑换时间"/>
      <el-table-column
        prop="status"
        label="订单状态"/>
      <el-table-column
        prop="invite_code"
        label="推荐人ID"/>
      <el-table-column
        fixed="right"
        label="管理"
        width="440">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            class="mini-el-button"
            @click="event().toDetailClick(scope.row.order_uuid)">
            详 情
          </el-button>
          <el-button
            v-if="scope.row.status == '待发货'"
            size="mini"
            type="primary"
            class="mini-el-button"
            @click="event().onDeliveryClick(scope.row.order_uuid)">
            确认发货
          </el-button>
          <el-button
            v-if="scope.row.status == '待收货'"
            size="mini"
            type="success"
            class="mini-el-button"
            @click="event().onConfirmClick(scope.row.order_uuid)">
            确认收货
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <div class="pagination-center">
      <el-pagination
        background
        @current-change="handleCurrentChange"
        :current-page.sync="body.page_index"
        :page-size="body.page_size"
        layout="prev, pager, next"
        :total="total"/>
    </div>

    <!-- 发货 -->
    <el-dialog
      width="480px"
      :title="deliveryTitle"
      :visible.sync="deliveryDialog">
      <el-form
        :model="deliver"
        label-position="left"
        :rules="rules2"
        ref="ruleForm2"
        label-width="120px"
        class="demo-ruleForm">
        <el-form-item
          label="物流单号："
          prop="logistics_num">
          <el-input
            class="dk-input"
            v-model="deliver.logistics_num"/>
        </el-form-item>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer">
        <el-button @click="deliveryDialog = false">取 消</el-button>
        <el-button
          type="primary"
          @click="event().onSureClick('ruleForm2')">确 定</el-button>
      </div>
    </el-dialog>
  </el-main>
</template>

<script>
import {
  getPointOrderList, closeRefundPointOrder, deliveryPointOrder,
  confirmPointOrder, getExportUrlPoint,
} from '../../api/order'
import { imgDomain, exportApi } from '../../configs/env'
import commoonFunction from '../../mixins/common'

export default {
  mixins: [commoonFunction],
  data() {
    return {
      url: '',
      deliveryTitle: '确认发货',
      deliveryDialog: false,
      imgDomain,
      orderArr: [
        {
          label: '全部',
          value: '',
        },
        {
          label: '待发货',
          value: '待发货',
        },
        {
          label: '待收货',
          value: '待收货',
        },
        {
          label: '已完成',
          value: '已完成',
        },
        {
          label: '已关闭',
          value: '已关闭',
        },
      ],
      body: {
        page_index: 1,
        page_size: 20,
        pay_type: '',
        create_begin_time: '',
        create_end_time: '',
        pay_begin_time: '',
        pay_end_time: '',
        keyword: '',
        status: '',
      },
      times: [],
      times1: [],
      total: 0,
      tableData: [
      ],
      rules2: {
        logistics_num: [
          { required: true, message: '请输入物流单号', trigger: 'blur' },
        ],
      },
      deliver: {
        logistics_num: '',
        uuid: '',
      },
    };
  },

  components: {
  },
  created() {
    this.network().getPointOrderList()
  },
  methods: {
    handleCurrentChange() {
      this.network().getPointOrderList()
    },
    onTimeChange() {
      // eslint-disable-next-line
      const [create_begin_time, create_end_time] = this.times?this.times:['','']
      this.body = Object.assign({}, this.body, { create_begin_time, create_end_time })
      this.handleCurrentChange()
    },
    onTimeChange1() {
      // eslint-disable-next-line
      const [pay_begin_time, pay_end_time] = this.times1?this.times1:['','']
      this.body = Object.assign({}, this.body, { pay_begin_time, pay_end_time })
      this.handleCurrentChange()
    },
    event() {
      return {
        toDetailClick: (uuid) => {
          this.$router.push({ path: 'point-detail', query: { uuid, type: 'point' } })
        },
        // eslint-disable-next-line
        oncloseRefundPointOrderClick: ({ order_uuid, status }) => {
          if (status === '待支付') {
            this.isDel('确定关闭该待支付订单, 是否继续?', 'closeCancelOrder', { uuid: order_uuid })
          } else {
            this.isDel('确定关闭该待发货订单, 是否继续?', 'closeRefundPointOrder', { uuid: order_uuid })
          }
        },
        onOfflinePayClick: (uuid) => {
          this.network().offlinePayOrder({ uuid })
        },
        onDeliveryClick: (uuid) => {
          this.deliver = { uuid, logistics_num: '' }
          this.deliveryDialog = true
        },
        onConfirmClick: (uuid) => {
          this.isDel('确定收货, 是否继续?', 'confirmPointOrder', { uuid })
        },
        onSureClick: (formName) => {
          this.$refs[formName].validate((valid) => {
            if (valid) {
              this.network().deliveryPointOrder()
            } else {
              console.log('error submit!!');
            }
          });
        },
        toExportClick: () => {
          this.network().getExportUrlPoint()
        },
      }
    },
    network() {
      return {
        getPointOrderList: async () => {
          const { status, data } = await getPointOrderList(this.body)
          if (status !== 200) return
          this.tableData = data.data
          this.total = data.total
        },
        closeRefundPointOrder: async (body) => {
          const { status } = await closeRefundPointOrder(body)
          if (status !== 200) return
          this.network().getPointOrderList()
          this.$notify({
            title: '关闭成功',
            message: '关闭待发货订单成功',
            type: 'success',
          });
        },
        confirmPointOrder: async (uuid) => {
          const { status } = await confirmPointOrder(uuid)
          if (status !== 200) return
          this.network().getPointOrderList()
          this.$notify({
            title: '确认收货',
            message: '订单确认收货成功',
            type: 'success',
          });
        },
        deliveryPointOrder: async () => {
          const { status } = await deliveryPointOrder(this.deliver)
          if (status !== 200) return
          this.network().getPointOrderList()
          this.deliveryDialog = false
          this.$notify({
            title: '发货成功',
            message: '订单发货成功',
            type: 'success',
          });
        },
        getExportUrlPoint: async () => {
          const { status, data } = await getExportUrlPoint(this.body)
          if (status !== 200) return
          this.url = exportApi + data.path
          this.$nextTick(() => {
            this.$refs.export.click()
          })
        },
      }
    },
    handler() {
      return {
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/styles/mixins.scss';
.table-top{
  @include dk-table-top;
}
</style>



// WEBPACK FOOTER //
// src/vuepage/order/point-list.vue